// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import socket from './socket';
import './Lobby.css';
import './components/StatsBar.css';
import './HeaderMobile.css';
import './HeaderDraw.css';

import { useTranslation } from 'react-i18next';

import LevelRewardModal from './components/LevelRewardModal';
import StatsBar from './components/StatsBar';
import LanguageSwitcher from './components/LanguageSwitcher';

export default function Header({
  username,
  userBalance,
  onLogout,
  userAvatar,
  userAssets = {}
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const drawMenuName = t('header.brackets');

  const [avatarUrl, setAvatarUrl] = useState(userAvatar || null);
  const [avatarVer, setAvatarVer] = useState(0);
  const [level, setLevel] = useState(1);
  const [levelPoints, setLevelPoints] = useState(0);
  const [nextLevelXP, setNextLevelXP] = useState(100);
  const [showGiftIcon, setShowGiftIcon] = useState(false);
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileHeader, setMobileHeader] = useState({
    active: false,
    zoom: 1,
    width: '100%',
  });

  // запоминаем предыдущие значения, чтобы ловить рост
const prevLevelRef = useRef(null);
const prevXPRef    = useRef(null);


// ↓↓↓ добавь это
const API_ORIGIN = process.env.REACT_APP_API_URL; // напр.: http://147.93.123.26:5000


// === SkyPay: попытка зачислить при возвращении на сайт ===
async function tryCreditPendingSkyPay() {
  // достаём pending
  let pending = null;
  try {
    const raw = localStorage.getItem('skypay:pending');
    if (raw) pending = JSON.parse(raw);
  } catch {}

  // если нечего подтверждать — выходим
  if (!pending) return;

  // подхватим paymentId/orderId из URL (если провайдер их добавил при редиректе)
  const url = new URL(window.location.href);
  const urlPaymentId =
    url.searchParams.get('payment_id') ||
    url.searchParams.get('paymentId') ||
    url.searchParams.get('id');
  const urlOrderId =
    url.searchParams.get('order_id') ||
    url.searchParams.get('order') ||
    url.searchParams.get('label');

  const body = {
    paymentId: urlPaymentId || pending.paymentId || null,
    orderId:   urlOrderId   || pending.orderId   || null,
    amount:    pending.amount ?? null,
    currency:  pending.currency || 'RUB', // сейчас работаем в рублях
  };

  // Мини-guard: если вообще нет идентификаторов, смысла бить бэкенд нет
  if (!body.paymentId && !body.orderId) return;

  const API_BASE = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';
  const token = localStorage.getItem('token');

  try {
    const res = await fetch(`${API_BASE}/skycryptoPayments/credit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });

    const raw = await res.text();
    let json = null;
    try { json = raw ? JSON.parse(raw) : null; } catch {}

    if (!res.ok) {
      console.warn('[SkyPay] credit failed:', res.status, json || raw);
      return; // не чистим pending — попробуем ещё раз при следующем фокусе
    }

    // успех — чистим pending, пушим обновление баланса
    try { localStorage.removeItem('skypay:pending'); } catch {}
    const newBalance = json?.balance;

    // ваш родитель слушает это событие и обновляет userBalance пропсом
    window.dispatchEvent(new CustomEvent('balance-updated', {
      detail: { balance: newBalance, source: 'skypay', allowDecrease: false }
    }));

    console.log('[SkyPay] credited. New balance =', newBalance);
  } catch (e) {
    console.warn('[SkyPay] credit exception:', e?.message || e);
    // pending оставляем — попробуем ещё при следующем фокусе/видимости
  }
}


const normalizeAvatarPath = (raw) => {
  if (!raw) return null;
  const s = String(raw).replace(/\\/g, '/'); // на всякий случай
  const m = s.match(/\/?uploads\/.*$/i);
  if (m) return '/' + m[0].replace(/^\/+/, '');
  const filename = s.split('/').pop();
  return filename ? `/uploads/avatars/${filename}` : null;
};





useEffect(() => {
  const onLevel = ({ level, levelPoints }) => {
    if (typeof level === 'number') setLevel(level);
    if (typeof levelPoints === 'number') setLevelPoints(levelPoints);
  };
  socket.on('userLevelUpdated', onLevel);
  return () => socket.off('userLevelUpdated', onLevel);
}, []);




useEffect(() => {
  console.log('[Header] prop userBalance =', userBalance);
}, [userBalance]);



// ✅ ПОВТОРНО проверяем награду при росте уровня/XP (без перезагрузки)
useEffect(() => {
  if (!username) return;

  const prevLevel = prevLevelRef.current;
  const prevXP    = prevXPRef.current;

  // условия: вырос уровень ИЛИ (уровень тот же, но выросли очки XP)
  const leveledUp   = (typeof prevLevel === 'number') && level > prevLevel;
  const xpIncreased = (typeof prevXP === 'number')    && level === prevLevel && levelPoints > prevXP;

  if (leveledUp || xpIncreased) {
    // перепроверяем у бэка: если награда в ожидании — покажем иконку
    fetch(`${API_ORIGIN}/api/auth/rewards/check?username=${encodeURIComponent(username)}`)
      .then(res => res.json())
      .then(data => {
        const pending = Boolean(data?.pending);
        if (pending) setShowGiftIcon(true);
      })
      .catch(err => console.error('[Header] re-check reward failed:', err));
  }

  // обновляем «прошлые» значения
  prevLevelRef.current = level;
  prevXPRef.current    = levelPoints;
}, [level, levelPoints, username, API_ORIGIN]);


const fetchLevel = async (name) => {
  if (!name) return;
  try {
    const { data } = await axios.get(
      `${API_ORIGIN}/api/auth/level?username=${encodeURIComponent(name)}`
    );
    setLevel(data.level);
    setLevelPoints(data.levelPoints);
    setNextLevelXP(data.nextLevelXP);
  } catch (e) {
    console.error('[Header] level refresh failed:', e);
  }
};

// слушатель «level-updated» (детали пришли — ставим напрямую, иначе рефетчим)
useEffect(() => {
  const onLvl = (e) => {
    const d = e?.detail || null;
    if (d && (typeof d.level === 'number' || typeof d.levelPoints === 'number')) {
      if (typeof d.level === 'number') setLevel(d.level);
      if (typeof d.levelPoints === 'number') setLevelPoints(d.levelPoints);
      // nextLevelXP по месту не считаем — просто перезагрузим фоном
      fetchLevel(username);
    } else {
      fetchLevel(username);
    }
  };
  window.addEventListener('level-updated', onLvl);
  window.addEventListener('level-refresh', onLvl);
  return () => {
    window.removeEventListener('level-updated', onLvl);
    window.removeEventListener('level-refresh', onLvl);
  };
}, [username]);





// При монтировании + при возврате фокуса/видимости — пытаемся зачесть оплату
useEffect(() => {
  const onFocus = () => tryCreditPendingSkyPay();
  const onVisible = () => {
    if (document.visibilityState === 'visible') tryCreditPendingSkyPay();
  };

  // 1) сразу при монтировании
  tryCreditPendingSkyPay();

  // 2) при возврате в вкладку / переключении окна
  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisible);

  return () => {
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisible);
  };
}, []);



 useEffect(() => {
  const onAvatarUpdated = (e) => {
    const next = e?.detail?.avatar || null;
    if (next) {
      const norm = normalizeAvatarPath(next);
      setAvatarUrl(norm);
      setAvatarVer(v => v + 1);
    }
  };
  window.addEventListener('avatar-updated', onAvatarUpdated);
  return () => window.removeEventListener('avatar-updated', onAvatarUpdated);
}, []);


  // грузим уровень
  useEffect(() => {
    if (!username) return;
    (async () => {
      try {
        const { data } = await axios.get(
      `${API_ORIGIN}/api/auth/level?username=${encodeURIComponent(username)}`
      );
        setLevel(data.level);
        setLevelPoints(data.levelPoints);
        setNextLevelXP(data.nextLevelXP);
      } catch (error) {
        console.error('Ошибка при получении уровня:', error);
      }
    })();
  }, [username]);

  // проверяем подарок
  useEffect(() => {
    const u = localStorage.getItem('username');
    if (!u) return;
    fetch(`${API_ORIGIN}/api/auth/rewards/check?username=${encodeURIComponent(u)}`)
      .then(res => res.json())
      .then(data => setShowGiftIcon(Boolean(data?.pending)))
      .catch(err => console.error('Ошибка проверки награды:', err));
  }, []);



  // ↓↓↓ добавь это (синк с пропсом и localStorage на монт/обновление)
useEffect(() => {
  if (userAvatar) {
    const norm = normalizeAvatarPath(userAvatar);
    setAvatarUrl(norm);
    setAvatarVer(v => v + 1); // ломаем кэш, если картинка та же
  } else {
    const fromLS = localStorage.getItem('avatar');
    if (fromLS) {
      const norm = normalizeAvatarPath(fromLS);
      setAvatarUrl(norm);
      setAvatarVer(v => v + 1);
    }
  }
}, [userAvatar]);



// Мобильная шапка работает даже без глобального meta viewport.
// Игровые доски остаются в старом масштабе, а увеличивается только header-wrap.
useEffect(() => {
  const calculateMobileHeader = () => {
    const screenWidth = Number(window.screen?.width || 0);
    const screenHeight = Number(window.screen?.height || 0);
    const shortSide = Math.min(
      screenWidth || 9999,
      screenHeight || 9999
    );

    const rawAngle = Number(
      window.screen?.orientation?.angle ??
      window.orientation ??
      0
    );

    const landscape = Math.abs(rawAngle) % 180 === 90;

    const deviceWidth = landscape
      ? Math.max(screenWidth, screenHeight)
      : shortSide;

    const layoutWidth = Number(
      document.documentElement.clientWidth ||
      window.innerWidth ||
      0
    );

    const hasTouch =
      Number(navigator.maxTouchPoints || 0) > 0 ||
      'ontouchstart' in window;

    const active = hasTouch && shortSide <= 900;

    const needsScaleCompensation =
      active &&
      deviceWidth > 0 &&
      layoutWidth > deviceWidth * 1.2;

    const rawZoom = needsScaleCompensation
      ? layoutWidth / deviceWidth
      : 1;

    const zoom = Math.round(
      Math.max(1, Math.min(rawZoom, 3.2)) * 1000
    ) / 1000;

    /*
      В режиме без meta viewport layout имеет ширину около 980px.
      Раньше здесь использовался процент (например 43.87%).
      В сочетании с CSS zoom вложенные элементы шапки повторно
      сжимались, поэтому в лобби StatsBar и header-inner занимали
      только левую часть.

      Фиксируем расчётную ширину шапки в реальных CSS-пикселях
      устройства, а zoom уже растягивает её до ширины layout.
    */
    const width = needsScaleCompensation
      ? `${Math.round(deviceWidth)}px`
      : '100%';

    setMobileHeader((prev) => {
      if (
        prev.active === active &&
        prev.zoom === zoom &&
        prev.width === width
      ) {
        return prev;
      }

      return {
        active,
        zoom,
        width,
      };
    });
  };

  calculateMobileHeader();

  window.addEventListener('resize', calculateMobileHeader);
  window.addEventListener('orientationchange', calculateMobileHeader);

  return () => {
    window.removeEventListener('resize', calculateMobileHeader);
    window.removeEventListener('orientationchange', calculateMobileHeader);
  };
}, []);

// После перехода по пункту меню закрываем выпадающий блок.
useEffect(() => {
  setMobileMenuOpen(false);
}, [location.pathname]);

// Закрытие по Escape.
useEffect(() => {
  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      setMobileMenuOpen(false);
    }
  };

  window.addEventListener('keydown', onKeyDown);
  return () => window.removeEventListener('keydown', onKeyDown);
}, []);

const closeMobileMenu = () => {
  setMobileMenuOpen(false);
};

const handleMobileLogout = () => {
  setMobileMenuOpen(false);
  onLogout();
};

const clubIcon = (
  <svg
    className="menu-item__icon menu-item__icon--club"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
  >
    <rect x="5" y="7" width="30" height="26" rx="7" stroke="currentColor" strokeWidth="2" />
    <circle cx="15" cy="18" r="4" stroke="currentColor" strokeWidth="2" />
    <circle cx="26" cy="17" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M9.5 28c1.3-4 4-6 7.5-6s6.2 2 7.5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M23 23c3.7.2 6 1.8 7 4.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);


const ticketsTotal = Array.isArray(userAssets?.tickets)
  ? userAssets.tickets.reduce((a,t)=> a + (Number(t.quantity)||0), 0)
  : 0;

const skinsTotal = Array.isArray(userAssets?.skins)
  ? userAssets.skins.reduce((a,s)=> a + (Number(s.quantity)||0), 0)
  : 0;

console.log('[Header] totals:', { ticketsTotal, skinsTotal });



  return (
    <div
      className={`header-wrap ${
        mobileHeader.active ? 'header-wrap--mobile' : ''
      }`}
      style={{
        '--header-mobile-zoom': mobileHeader.zoom,
        '--header-mobile-width': mobileHeader.width,
      }}
    >
      <header className="header-banner">
        <div className="header-inner">
          {/* ЛОГО */}
          <NavLink
            to="/"
            className="logo"
            aria-label="Backgammon Quest"
            onClick={closeMobileMenu}
          >
            <span className="logo-mark" aria-hidden="true">
              BQ
            </span>
            <span className="main">Backgammon</span>
            <span className="highlight">Quest</span>
          </NavLink>

          {/* ДЕСКТОПНОЕ МЕНЮ */}
          <div className="menu-wrap menu-wrap--desktop">
            <nav className="menu">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                }
              >
                <img
                  src="/img/bgIcon.png"
                  alt={t('header.backgammon')}
                  className="menu-item__icon"
                />
                <span className="menu-item__text">
                  {t('header.backgammon')}
                </span>
              </NavLink>

              <NavLink
                to="/quests"
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                }
              >
                <img
                  src="/img/questIcon.png"
                  alt={t('header.quests')}
                  className="menu-item__icon"
                />
                <span className="menu-item__text">
                  {t('header.quests')}
                </span>
              </NavLink>

              <NavLink
                to="/poker"
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                }
              >
                <img
                  src="/img/pokerIcon.png"
                  alt={t('header.poker')}
                  className="menu-item__icon"
                />
                <span className="menu-item__text">
                  {t('header.poker')}
                </span>
              </NavLink>

              {/*
              <NavLink
                to="/satellites"
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                }
              >
                <img
                  src="/img/SatelliteIcon.png"
                  alt={t('header.satellites')}
                  className="menu-item__icon"
                />
                <span className="menu-item__text">
                  {t('header.satellites')}
                </span>
              </NavLink>
              */}

              <NavLink
                to="/big-tournaments"
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                }
              >
                <svg
                  className="menu-item__icon"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12 8h16v5c0 7-3 11-8 13-5-2-8-6-8-13V8Z"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 11H7c0 6 2 9 7 10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M28 11h5c0 6-2 9-7 10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M20 26v5M14 33h12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>

                <span className="menu-item__text">
                  {t('header.tournaments')}
                </span>
              </NavLink>

              {/* Публичный раздел жеребьёвок: доступен и гостям. */}
              <NavLink
                to="/draws"
                title={drawMenuName}
                className={({ isActive }) =>
                  `menu-item menu-item--with-icon menu-item--draw ${isActive ? 'active' : ''}`
                }
              >
                <svg className="menu-item__icon" width="40" height="40"
                  viewBox="0 0 40 40" fill="none" aria-hidden="true">
                  <rect x="3" y="5" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <rect x="3" y="25" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <rect x="27" y="15" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M13 10h7v10h7M13 30h7V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span className="menu-item__text">{drawMenuName}</span>
              </NavLink>

              {username && (
                <NavLink
                  to="/profile/club"
                  className={({ isActive }) =>
                    `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
                  }
                >
                  {clubIcon}
                  <span className="menu-item__text">
                    {t('header.clubs')}
                  </span>
                </NavLink>
              )}
            </nav>
          </div>

          {/* ПРАВЫЙ БЛОК */}
          <div className="buttons">
            <LanguageSwitcher />

            {!username ? (
              <>
                <button
                  type="button"
                  className="button-login"
                  onClick={() => navigate('/login')}
                >
                  {t('header.login')}
                </button>

                <button
                  type="button"
                  className="button-register"
                  onClick={() => navigate('/register')}
                >
                  {t('header.register')}
                </button>
              </>
            ) : (
              <div className="userbox">
                {avatarUrl && (
                  <span className="userbox__avatar-wrap">
                    <img
                      className="userbox__avatar"
                      src={`${API_ORIGIN}${avatarUrl}?v=${avatarVer}`}
                      alt={t('header.avatarAlt')}
                      onError={(event) => {
                        console.error(
                          '[Header] IMG LOAD ERROR',
                          event.currentTarget.src
                        );
                      }}
                    />
                  </span>
                )}

                <div className="userbox__info">
                  <div className="userbox__line">
                    <span className="userbox__name">{username}</span>
                    <span
                      key={`cash-${userBalance}`}
                      className="userbox__money"
                      data-balance-target="cash"
                    >
                      ${Number(userBalance || 0).toFixed(2)}
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className="button-profile"
                  onClick={() => navigate('/profile')}
                  aria-label={t('header.profile')}
                  title={t('header.profile')}
                >
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="4" stroke="#fff" strokeWidth="2" />
                    <path
                      d="M4 20c1-4 4-6 8-6s7 2 8 6"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>

                <button
                  type="button"
                  className="button-logout"
                  onClick={onLogout}
                  aria-label={t('header.logout')}
                  title={t('header.logout')}
                >
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M16 17l5-5-5-5"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21 12H9"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M12 19H5a2 2 0 01-2-2V7a2 2 0 012-2h7"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>

          {/* БУРГЕР — виден только в мобильном режиме */}
          <button
            type="button"
            className={`header-burger ${mobileMenuOpen ? 'is-open' : ''}`}
            aria-label={
              mobileMenuOpen
                ? t('header.closeMenu')
                : t('header.openMenu')
            }
            aria-expanded={mobileMenuOpen}
            aria-controls="header-mobile-menu"
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      {/* МОБИЛЬНОЕ ВЫПАДАЮЩЕЕ МЕНЮ */}
      <div
        id="header-mobile-menu"
        className={`header-mobile-menu ${mobileMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!mobileMenuOpen}
      >
        <nav className="header-mobile-menu__nav">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{t('header.backgammon')}</span>
            <span aria-hidden="true">›</span>
          </NavLink>

          <NavLink
            to="/quests"
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{t('header.quests')}</span>
            <span aria-hidden="true">›</span>
          </NavLink>

          <NavLink
            to="/poker"
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{t('header.poker')}</span>
            <span aria-hidden="true">›</span>
          </NavLink>

          {/* <NavLink
            to="/satellites"
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{t('header.satellites')}</span>
            <span aria-hidden="true">›</span>
          </NavLink> */}

          <NavLink
            to="/big-tournaments"
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{t('header.tournaments')}</span>
            <span aria-hidden="true">›</span>
          </NavLink>

          <NavLink
            to="/draws"
            className={({ isActive }) =>
              `header-mobile-menu__link ${isActive ? 'active' : ''}`
            }
            onClick={closeMobileMenu}
          >
            <span>{drawMenuName}</span><span aria-hidden="true">›</span>
          </NavLink>

          {username && (
            <NavLink
              to="/profile/club"
              className={({ isActive }) =>
                `header-mobile-menu__link ${isActive ? 'active' : ''}`
              }
              onClick={closeMobileMenu}
            >
              <span>{t('header.clubs')}</span>
              <span aria-hidden="true">›</span>
            </NavLink>
          )}
        </nav>

        <div className="header-mobile-menu__language">
          <LanguageSwitcher compact />
        </div>

        <div className="header-mobile-menu__footer">
          {username ? (
            <>
              <button
                type="button"
                className="header-mobile-menu__action"
                onClick={() => {
                  closeMobileMenu();
                  navigate('/profile');
                }}
              >
                {t('header.profile')}
              </button>

              <button
                type="button"
                className="header-mobile-menu__action header-mobile-menu__action--danger"
                onClick={handleMobileLogout}
              >
                {t('header.logout')}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="header-mobile-menu__action"
                onClick={() => {
                  closeMobileMenu();
                  navigate('/login');
                }}
              >
                {t('header.signIn')}
              </button>

              <button
                type="button"
                className="header-mobile-menu__action header-mobile-menu__action--gold"
                onClick={() => {
                  closeMobileMenu();
                  navigate('/register');
                }}
              >
                {t('header.register')}
              </button>
            </>
          )}
        </div>
      </div>

      {/* СТАТУС-БАР */}
      <div className="statsbar-dock">
        <StatsBar
          key={`stats-${ticketsTotal}-${skinsTotal}-${levelPoints}`}
          userAssets={userAssets}
          level={level}
          levelPoints={levelPoints}
          nextLevelXP={nextLevelXP}
          showGiftIcon={showGiftIcon}
          setShowGiftIcon={setShowGiftIcon}
          onGiftClick={() => setShowRewardModal(true)}
          onTicketsClick={() => navigate('/profile/tickets')}
          onSkinsClick={() => navigate('/profile/skins')}
          onLevelClick={() => navigate('/profile/level')}
        />
      </div>

      <LevelRewardModal
        username={username}
        showRewardModal={showRewardModal}
        setShowRewardModal={setShowRewardModal}
        setShowGiftIcon={setShowGiftIcon}
      />
    </div>
  );
}



// // src/components/Header.js
// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import socket from './socket';
// import './Lobby.css';
// import './components/StatsBar.css';
// import './HeaderMobile.css';

// import { useTranslation } from 'react-i18next';

// import LevelRewardModal from './components/LevelRewardModal';
// import StatsBar from './components/StatsBar';
// import LanguageSwitcher from './components/LanguageSwitcher';

// export default function Header({
//   username,
//   userBalance,
//   onLogout,
//   userAvatar,
//   userAssets = {}
// }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { t } = useTranslation();

//   const [avatarUrl, setAvatarUrl] = useState(userAvatar || null);
//   const [avatarVer, setAvatarVer] = useState(0);
//   const [level, setLevel] = useState(1);
//   const [levelPoints, setLevelPoints] = useState(0);
//   const [nextLevelXP, setNextLevelXP] = useState(100);
//   const [showGiftIcon, setShowGiftIcon] = useState(false);
//   const [showRewardModal, setShowRewardModal] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [mobileHeader, setMobileHeader] = useState({
//     active: false,
//     zoom: 1,
//     width: '100%',
//   });

//   // запоминаем предыдущие значения, чтобы ловить рост
// const prevLevelRef = useRef(null);
// const prevXPRef    = useRef(null);


// // ↓↓↓ добавь это
// const API_ORIGIN = process.env.REACT_APP_API_URL; // напр.: http://147.93.123.26:5000


// // === SkyPay: попытка зачислить при возвращении на сайт ===
// async function tryCreditPendingSkyPay() {
//   // достаём pending
//   let pending = null;
//   try {
//     const raw = localStorage.getItem('skypay:pending');
//     if (raw) pending = JSON.parse(raw);
//   } catch {}

//   // если нечего подтверждать — выходим
//   if (!pending) return;

//   // подхватим paymentId/orderId из URL (если провайдер их добавил при редиректе)
//   const url = new URL(window.location.href);
//   const urlPaymentId =
//     url.searchParams.get('payment_id') ||
//     url.searchParams.get('paymentId') ||
//     url.searchParams.get('id');
//   const urlOrderId =
//     url.searchParams.get('order_id') ||
//     url.searchParams.get('order') ||
//     url.searchParams.get('label');

//   const body = {
//     paymentId: urlPaymentId || pending.paymentId || null,
//     orderId:   urlOrderId   || pending.orderId   || null,
//     amount:    pending.amount ?? null,
//     currency:  pending.currency || 'RUB', // сейчас работаем в рублях
//   };

//   // Мини-guard: если вообще нет идентификаторов, смысла бить бэкенд нет
//   if (!body.paymentId && !body.orderId) return;

//   const API_BASE = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';
//   const token = localStorage.getItem('token');

//   try {
//     const res = await fetch(`${API_BASE}/skycryptoPayments/credit`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       },
//       body: JSON.stringify(body),
//     });

//     const raw = await res.text();
//     let json = null;
//     try { json = raw ? JSON.parse(raw) : null; } catch {}

//     if (!res.ok) {
//       console.warn('[SkyPay] credit failed:', res.status, json || raw);
//       return; // не чистим pending — попробуем ещё раз при следующем фокусе
//     }

//     // успех — чистим pending, пушим обновление баланса
//     try { localStorage.removeItem('skypay:pending'); } catch {}
//     const newBalance = json?.balance;

//     // ваш родитель слушает это событие и обновляет userBalance пропсом
//     window.dispatchEvent(new CustomEvent('balance-updated', {
//       detail: { balance: newBalance, source: 'skypay', allowDecrease: false }
//     }));

//     console.log('[SkyPay] credited. New balance =', newBalance);
//   } catch (e) {
//     console.warn('[SkyPay] credit exception:', e?.message || e);
//     // pending оставляем — попробуем ещё при следующем фокусе/видимости
//   }
// }


// const normalizeAvatarPath = (raw) => {
//   if (!raw) return null;
//   const s = String(raw).replace(/\\/g, '/'); // на всякий случай
//   const m = s.match(/\/?uploads\/.*$/i);
//   if (m) return '/' + m[0].replace(/^\/+/, '');
//   const filename = s.split('/').pop();
//   return filename ? `/uploads/avatars/${filename}` : null;
// };





// useEffect(() => {
//   const onLevel = ({ level, levelPoints }) => {
//     if (typeof level === 'number') setLevel(level);
//     if (typeof levelPoints === 'number') setLevelPoints(levelPoints);
//   };
//   socket.on('userLevelUpdated', onLevel);
//   return () => socket.off('userLevelUpdated', onLevel);
// }, []);




// useEffect(() => {
//   console.log('[Header] prop userBalance =', userBalance);
// }, [userBalance]);



// // ✅ ПОВТОРНО проверяем награду при росте уровня/XP (без перезагрузки)
// useEffect(() => {
//   if (!username) return;

//   const prevLevel = prevLevelRef.current;
//   const prevXP    = prevXPRef.current;

//   // условия: вырос уровень ИЛИ (уровень тот же, но выросли очки XP)
//   const leveledUp   = (typeof prevLevel === 'number') && level > prevLevel;
//   const xpIncreased = (typeof prevXP === 'number')    && level === prevLevel && levelPoints > prevXP;

//   if (leveledUp || xpIncreased) {
//     // перепроверяем у бэка: если награда в ожидании — покажем иконку
//     fetch(`${API_ORIGIN}/api/auth/rewards/check?username=${encodeURIComponent(username)}`)
//       .then(res => res.json())
//       .then(data => {
//         const pending = Boolean(data?.pending);
//         if (pending) setShowGiftIcon(true);
//       })
//       .catch(err => console.error('[Header] re-check reward failed:', err));
//   }

//   // обновляем «прошлые» значения
//   prevLevelRef.current = level;
//   prevXPRef.current    = levelPoints;
// }, [level, levelPoints, username, API_ORIGIN]);


// const fetchLevel = async (name) => {
//   if (!name) return;
//   try {
//     const { data } = await axios.get(
//       `${API_ORIGIN}/api/auth/level?username=${encodeURIComponent(name)}`
//     );
//     setLevel(data.level);
//     setLevelPoints(data.levelPoints);
//     setNextLevelXP(data.nextLevelXP);
//   } catch (e) {
//     console.error('[Header] level refresh failed:', e);
//   }
// };

// // слушатель «level-updated» (детали пришли — ставим напрямую, иначе рефетчим)
// useEffect(() => {
//   const onLvl = (e) => {
//     const d = e?.detail || null;
//     if (d && (typeof d.level === 'number' || typeof d.levelPoints === 'number')) {
//       if (typeof d.level === 'number') setLevel(d.level);
//       if (typeof d.levelPoints === 'number') setLevelPoints(d.levelPoints);
//       // nextLevelXP по месту не считаем — просто перезагрузим фоном
//       fetchLevel(username);
//     } else {
//       fetchLevel(username);
//     }
//   };
//   window.addEventListener('level-updated', onLvl);
//   window.addEventListener('level-refresh', onLvl);
//   return () => {
//     window.removeEventListener('level-updated', onLvl);
//     window.removeEventListener('level-refresh', onLvl);
//   };
// }, [username]);





// // При монтировании + при возврате фокуса/видимости — пытаемся зачесть оплату
// useEffect(() => {
//   const onFocus = () => tryCreditPendingSkyPay();
//   const onVisible = () => {
//     if (document.visibilityState === 'visible') tryCreditPendingSkyPay();
//   };

//   // 1) сразу при монтировании
//   tryCreditPendingSkyPay();

//   // 2) при возврате в вкладку / переключении окна
//   window.addEventListener('focus', onFocus);
//   document.addEventListener('visibilitychange', onVisible);

//   return () => {
//     window.removeEventListener('focus', onFocus);
//     document.removeEventListener('visibilitychange', onVisible);
//   };
// }, []);



//  useEffect(() => {
//   const onAvatarUpdated = (e) => {
//     const next = e?.detail?.avatar || null;
//     if (next) {
//       const norm = normalizeAvatarPath(next);
//       setAvatarUrl(norm);
//       setAvatarVer(v => v + 1);
//     }
//   };
//   window.addEventListener('avatar-updated', onAvatarUpdated);
//   return () => window.removeEventListener('avatar-updated', onAvatarUpdated);
// }, []);


//   // грузим уровень
//   useEffect(() => {
//     if (!username) return;
//     (async () => {
//       try {
//         const { data } = await axios.get(
//       `${API_ORIGIN}/api/auth/level?username=${encodeURIComponent(username)}`
//       );
//         setLevel(data.level);
//         setLevelPoints(data.levelPoints);
//         setNextLevelXP(data.nextLevelXP);
//       } catch (error) {
//         console.error('Ошибка при получении уровня:', error);
//       }
//     })();
//   }, [username]);

//   // проверяем подарок
//   useEffect(() => {
//     const u = localStorage.getItem('username');
//     if (!u) return;
//     fetch(`${API_ORIGIN}/api/auth/rewards/check?username=${encodeURIComponent(u)}`)
//       .then(res => res.json())
//       .then(data => setShowGiftIcon(Boolean(data?.pending)))
//       .catch(err => console.error('Ошибка проверки награды:', err));
//   }, []);



//   // ↓↓↓ добавь это (синк с пропсом и localStorage на монт/обновление)
// useEffect(() => {
//   if (userAvatar) {
//     const norm = normalizeAvatarPath(userAvatar);
//     setAvatarUrl(norm);
//     setAvatarVer(v => v + 1); // ломаем кэш, если картинка та же
//   } else {
//     const fromLS = localStorage.getItem('avatar');
//     if (fromLS) {
//       const norm = normalizeAvatarPath(fromLS);
//       setAvatarUrl(norm);
//       setAvatarVer(v => v + 1);
//     }
//   }
// }, [userAvatar]);



// // Мобильная шапка работает даже без глобального meta viewport.
// // Игровые доски остаются в старом масштабе, а увеличивается только header-wrap.
// useEffect(() => {
//   const calculateMobileHeader = () => {
//     const screenWidth = Number(window.screen?.width || 0);
//     const screenHeight = Number(window.screen?.height || 0);
//     const shortSide = Math.min(
//       screenWidth || 9999,
//       screenHeight || 9999
//     );

//     const rawAngle = Number(
//       window.screen?.orientation?.angle ??
//       window.orientation ??
//       0
//     );

//     const landscape = Math.abs(rawAngle) % 180 === 90;

//     const deviceWidth = landscape
//       ? Math.max(screenWidth, screenHeight)
//       : shortSide;

//     const layoutWidth = Number(
//       document.documentElement.clientWidth ||
//       window.innerWidth ||
//       0
//     );

//     const hasTouch =
//       Number(navigator.maxTouchPoints || 0) > 0 ||
//       'ontouchstart' in window;

//     const active = hasTouch && shortSide <= 900;

//     const needsScaleCompensation =
//       active &&
//       deviceWidth > 0 &&
//       layoutWidth > deviceWidth * 1.2;

//     const rawZoom = needsScaleCompensation
//       ? layoutWidth / deviceWidth
//       : 1;

//     const zoom = Math.round(
//       Math.max(1, Math.min(rawZoom, 3.2)) * 1000
//     ) / 1000;

//     /*
//       В режиме без meta viewport layout имеет ширину около 980px.
//       Раньше здесь использовался процент (например 43.87%).
//       В сочетании с CSS zoom вложенные элементы шапки повторно
//       сжимались, поэтому в лобби StatsBar и header-inner занимали
//       только левую часть.

//       Фиксируем расчётную ширину шапки в реальных CSS-пикселях
//       устройства, а zoom уже растягивает её до ширины layout.
//     */
//     const width = needsScaleCompensation
//       ? `${Math.round(deviceWidth)}px`
//       : '100%';

//     setMobileHeader((prev) => {
//       if (
//         prev.active === active &&
//         prev.zoom === zoom &&
//         prev.width === width
//       ) {
//         return prev;
//       }

//       return {
//         active,
//         zoom,
//         width,
//       };
//     });
//   };

//   calculateMobileHeader();

//   window.addEventListener('resize', calculateMobileHeader);
//   window.addEventListener('orientationchange', calculateMobileHeader);

//   return () => {
//     window.removeEventListener('resize', calculateMobileHeader);
//     window.removeEventListener('orientationchange', calculateMobileHeader);
//   };
// }, []);

// // После перехода по пункту меню закрываем выпадающий блок.
// useEffect(() => {
//   setMobileMenuOpen(false);
// }, [location.pathname]);

// // Закрытие по Escape.
// useEffect(() => {
//   const onKeyDown = (event) => {
//     if (event.key === 'Escape') {
//       setMobileMenuOpen(false);
//     }
//   };

//   window.addEventListener('keydown', onKeyDown);
//   return () => window.removeEventListener('keydown', onKeyDown);
// }, []);

// const closeMobileMenu = () => {
//   setMobileMenuOpen(false);
// };

// const handleMobileLogout = () => {
//   setMobileMenuOpen(false);
//   onLogout();
// };

// const clubIcon = (
//   <svg
//     className="menu-item__icon menu-item__icon--club"
//     width="40"
//     height="40"
//     viewBox="0 0 40 40"
//     fill="none"
//     aria-hidden="true"
//   >
//     <rect x="5" y="7" width="30" height="26" rx="7" stroke="currentColor" strokeWidth="2" />
//     <circle cx="15" cy="18" r="4" stroke="currentColor" strokeWidth="2" />
//     <circle cx="26" cy="17" r="3" stroke="currentColor" strokeWidth="2" />
//     <path d="M9.5 28c1.3-4 4-6 7.5-6s6.2 2 7.5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//     <path d="M23 23c3.7.2 6 1.8 7 4.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//   </svg>
// );


// const ticketsTotal = Array.isArray(userAssets?.tickets)
//   ? userAssets.tickets.reduce((a,t)=> a + (Number(t.quantity)||0), 0)
//   : 0;

// const skinsTotal = Array.isArray(userAssets?.skins)
//   ? userAssets.skins.reduce((a,s)=> a + (Number(s.quantity)||0), 0)
//   : 0;

// console.log('[Header] totals:', { ticketsTotal, skinsTotal });



//   return (
//     <div
//       className={`header-wrap ${
//         mobileHeader.active ? 'header-wrap--mobile' : ''
//       }`}
//       style={{
//         '--header-mobile-zoom': mobileHeader.zoom,
//         '--header-mobile-width': mobileHeader.width,
//       }}
//     >
//       <header className="header-banner">
//         <div className="header-inner">
//           {/* ЛОГО */}
//           <NavLink
//             to="/"
//             className="logo"
//             aria-label="Backgammon Quest"
//             onClick={closeMobileMenu}
//           >
//             <span className="logo-mark" aria-hidden="true">
//               BQ
//             </span>
//             <span className="main">Backgammon</span>
//             <span className="highlight">Quest</span>
//           </NavLink>

//           {/* ДЕСКТОПНОЕ МЕНЮ */}
//           <div className="menu-wrap menu-wrap--desktop">
//             <nav className="menu">
//               <NavLink
//                 to="/"
//                 end
//                 className={({ isActive }) =>
//                   `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                 }
//               >
//                 <img
//                   src="/img/bgIcon.png"
//                   alt={t('header.backgammon')}
//                   className="menu-item__icon"
//                 />
//                 <span className="menu-item__text">
//                   {t('header.backgammon')}
//                 </span>
//               </NavLink>

//               <NavLink
//                 to="/quests"
//                 className={({ isActive }) =>
//                   `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                 }
//               >
//                 <img
//                   src="/img/questIcon.png"
//                   alt={t('header.quests')}
//                   className="menu-item__icon"
//                 />
//                 <span className="menu-item__text">
//                   {t('header.quests')}
//                 </span>
//               </NavLink>

//               <NavLink
//                 to="/poker"
//                 className={({ isActive }) =>
//                   `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                 }
//               >
//                 <img
//                   src="/img/pokerIcon.png"
//                   alt={t('header.poker')}
//                   className="menu-item__icon"
//                 />
//                 <span className="menu-item__text">
//                   {t('header.poker')}
//                 </span>
//               </NavLink>

//               {/*
//               <NavLink
//                 to="/satellites"
//                 className={({ isActive }) =>
//                   `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                 }
//               >
//                 <img
//                   src="/img/SatelliteIcon.png"
//                   alt={t('header.satellites')}
//                   className="menu-item__icon"
//                 />
//                 <span className="menu-item__text">
//                   {t('header.satellites')}
//                 </span>
//               </NavLink>
//               */}

//               <NavLink
//                 to="/big-tournaments"
//                 className={({ isActive }) =>
//                   `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                 }
//               >
//                 <svg
//                   className="menu-item__icon"
//                   width="40"
//                   height="40"
//                   viewBox="0 0 40 40"
//                   fill="none"
//                   aria-hidden="true"
//                 >
//                   <path
//                     d="M12 8h16v5c0 7-3 11-8 13-5-2-8-6-8-13V8Z"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   />
//                   <path
//                     d="M12 11H7c0 6 2 9 7 10"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                   <path
//                     d="M28 11h5c0 6-2 9-7 10"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                   <path
//                     d="M20 26v5M14 33h12"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                 </svg>

//                 <span className="menu-item__text">
//                   {t('header.tournaments')}
//                 </span>
//               </NavLink>

//               {username && (
//                 <NavLink
//                   to="/profile/club"
//                   className={({ isActive }) =>
//                     `menu-item menu-item--with-icon ${isActive ? 'active' : ''}`
//                   }
//                 >
//                   {clubIcon}
//                   <span className="menu-item__text">
//                     {t('header.clubs')}
//                   </span>
//                 </NavLink>
//               )}
//             </nav>
//           </div>

//           {/* ПРАВЫЙ БЛОК */}
//           <div className="buttons">
//             <LanguageSwitcher />

//             {!username ? (
//               <>
//                 <button
//                   type="button"
//                   className="button-login"
//                   onClick={() => navigate('/login')}
//                 >
//                   {t('header.login')}
//                 </button>

//                 <button
//                   type="button"
//                   className="button-register"
//                   onClick={() => navigate('/register')}
//                 >
//                   {t('header.register')}
//                 </button>
//               </>
//             ) : (
//               <div className="userbox">
//                 {avatarUrl && (
//                   <span className="userbox__avatar-wrap">
//                     <img
//                       className="userbox__avatar"
//                       src={`${API_ORIGIN}${avatarUrl}?v=${avatarVer}`}
//                       alt={t('header.avatarAlt')}
//                       onError={(event) => {
//                         console.error(
//                           '[Header] IMG LOAD ERROR',
//                           event.currentTarget.src
//                         );
//                       }}
//                     />
//                   </span>
//                 )}

//                 <div className="userbox__info">
//                   <div className="userbox__line">
//                     <span className="userbox__name">{username}</span>
//                     <span
//                       key={`cash-${userBalance}`}
//                       className="userbox__money"
//                       data-balance-target="cash"
//                     >
//                       ${Number(userBalance || 0).toFixed(2)}
//                     </span>
//                   </div>
//                 </div>

//                 <button
//                   type="button"
//                   className="button-profile"
//                   onClick={() => navigate('/profile')}
//                   aria-label={t('header.profile')}
//                   title={t('header.profile')}
//                 >
//                   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//                     <circle cx="12" cy="8" r="4" stroke="#fff" strokeWidth="2" />
//                     <path
//                       d="M4 20c1-4 4-6 8-6s7 2 8 6"
//                       stroke="#fff"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                     />
//                   </svg>
//                 </button>

//                 <button
//                   type="button"
//                   className="button-logout"
//                   onClick={onLogout}
//                   aria-label={t('header.logout')}
//                   title={t('header.logout')}
//                 >
//                   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M16 17l5-5-5-5"
//                       stroke="#fff"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                     <path
//                       d="M21 12H9"
//                       stroke="#fff"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                     />
//                     <path
//                       d="M12 19H5a2 2 0 01-2-2V7a2 2 0 012-2h7"
//                       stroke="#fff"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                     />
//                   </svg>
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* БУРГЕР — виден только в мобильном режиме */}
//           <button
//             type="button"
//             className={`header-burger ${mobileMenuOpen ? 'is-open' : ''}`}
//             aria-label={
//               mobileMenuOpen
//                 ? t('header.closeMenu')
//                 : t('header.openMenu')
//             }
//             aria-expanded={mobileMenuOpen}
//             aria-controls="header-mobile-menu"
//             onClick={() => setMobileMenuOpen((open) => !open)}
//           >
//             <span />
//             <span />
//             <span />
//           </button>
//         </div>
//       </header>

//       {/* МОБИЛЬНОЕ ВЫПАДАЮЩЕЕ МЕНЮ */}
//       <div
//         id="header-mobile-menu"
//         className={`header-mobile-menu ${mobileMenuOpen ? 'is-open' : ''}`}
//         aria-hidden={!mobileMenuOpen}
//       >
//         <nav className="header-mobile-menu__nav">
//           <NavLink
//             to="/"
//             end
//             className={({ isActive }) =>
//               `header-mobile-menu__link ${isActive ? 'active' : ''}`
//             }
//             onClick={closeMobileMenu}
//           >
//             <span>{t('header.backgammon')}</span>
//             <span aria-hidden="true">›</span>
//           </NavLink>

//           <NavLink
//             to="/quests"
//             className={({ isActive }) =>
//               `header-mobile-menu__link ${isActive ? 'active' : ''}`
//             }
//             onClick={closeMobileMenu}
//           >
//             <span>{t('header.quests')}</span>
//             <span aria-hidden="true">›</span>
//           </NavLink>

//           <NavLink
//             to="/poker"
//             className={({ isActive }) =>
//               `header-mobile-menu__link ${isActive ? 'active' : ''}`
//             }
//             onClick={closeMobileMenu}
//           >
//             <span>{t('header.poker')}</span>
//             <span aria-hidden="true">›</span>
//           </NavLink>

//           {/* <NavLink
//             to="/satellites"
//             className={({ isActive }) =>
//               `header-mobile-menu__link ${isActive ? 'active' : ''}`
//             }
//             onClick={closeMobileMenu}
//           >
//             <span>{t('header.satellites')}</span>
//             <span aria-hidden="true">›</span>
//           </NavLink> */}

//           <NavLink
//             to="/big-tournaments"
//             className={({ isActive }) =>
//               `header-mobile-menu__link ${isActive ? 'active' : ''}`
//             }
//             onClick={closeMobileMenu}
//           >
//             <span>{t('header.tournaments')}</span>
//             <span aria-hidden="true">›</span>
//           </NavLink>

//           {username && (
//             <NavLink
//               to="/profile/club"
//               className={({ isActive }) =>
//                 `header-mobile-menu__link ${isActive ? 'active' : ''}`
//               }
//               onClick={closeMobileMenu}
//             >
//               <span>{t('header.clubs')}</span>
//               <span aria-hidden="true">›</span>
//             </NavLink>
//           )}
//         </nav>

//         <div className="header-mobile-menu__language">
//           <LanguageSwitcher compact />
//         </div>

//         <div className="header-mobile-menu__footer">
//           {username ? (
//             <>
//               <button
//                 type="button"
//                 className="header-mobile-menu__action"
//                 onClick={() => {
//                   closeMobileMenu();
//                   navigate('/profile');
//                 }}
//               >
//                 {t('header.profile')}
//               </button>

//               <button
//                 type="button"
//                 className="header-mobile-menu__action header-mobile-menu__action--danger"
//                 onClick={handleMobileLogout}
//               >
//                 {t('header.logout')}
//               </button>
//             </>
//           ) : (
//             <>
//               <button
//                 type="button"
//                 className="header-mobile-menu__action"
//                 onClick={() => {
//                   closeMobileMenu();
//                   navigate('/login');
//                 }}
//               >
//                 {t('header.signIn')}
//               </button>

//               <button
//                 type="button"
//                 className="header-mobile-menu__action header-mobile-menu__action--gold"
//                 onClick={() => {
//                   closeMobileMenu();
//                   navigate('/register');
//                 }}
//               >
//                 {t('header.register')}
//               </button>
//             </>
//           )}
//         </div>
//       </div>

//       {/* СТАТУС-БАР */}
//       <div className="statsbar-dock">
//         <StatsBar
//           key={`stats-${ticketsTotal}-${skinsTotal}-${levelPoints}`}
//           userAssets={userAssets}
//           level={level}
//           levelPoints={levelPoints}
//           nextLevelXP={nextLevelXP}
//           showGiftIcon={showGiftIcon}
//           setShowGiftIcon={setShowGiftIcon}
//           onGiftClick={() => setShowRewardModal(true)}
//           onTicketsClick={() => navigate('/profile/tickets')}
//           onSkinsClick={() => navigate('/profile/skins')}
//           onLevelClick={() => navigate('/profile/level')}
//         />
//       </div>

//       <LevelRewardModal
//         username={username}
//         showRewardModal={showRewardModal}
//         setShowRewardModal={setShowRewardModal}
//         setShowGiftIcon={setShowGiftIcon}
//       />
//     </div>
//   );
// }
